export default "/icon-sign-out.svg";